// Campus photo for /colleges/university-of-south-carolina: CC BY-SA 4.0, by ProfReader, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ASouth_Caroliniana_Library.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-south-carolina/; credited under the photo.
const photo = {
    "slug": "university-of-south-carolina",
    "alt": "The South Caroliniana Library on the Horseshoe at the University of South Carolina in Columbia, South Carolina",
    "src": "/colleges/university-of-south-carolina/campus-1600.webp",
    "srcSmall": "/colleges/university-of-south-carolina/campus-800.webp",
    "srcMid": "/colleges/university-of-south-carolina/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-south-carolina/og.jpg",
    "title": "South Caroliniana Library",
    "author": "ProfReader",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ASouth_Caroliniana_Library.jpg",
    "read": "2026-10-01"
};

export default photo;
